// extracted by mini-css-extract-plugin
export var clickable = "PickSlipMessage-module--clickable--6ebd9";